module.exports = __webpack_public_path__ + "static/media/Yoga_Kriya.1f650797.png";